import { startOfDay } from 'date-fns';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { noop } from '../../utils/noop.esm.js';
import '@popperjs/core';
import { Button } from '../Button/Button.esm.js';
import '@panwds/icons';
import '@panwds/tailwindcss';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { Field } from '../Field/Field.esm.js';
import { Calendar } from './Calendar/Calendar.esm.js';
import { MAX_DATE, MIN_DATE } from './constants.esm.js';
import { DateInput } from './DateInput.esm.js';
import { DatePickerLayout } from './DatePickerLayout.esm.js';
import { cancelMessage, applyMessage } from './messages.esm.js';
import { useActiveDate } from './useActiveDate.esm.js';

/**
 * Allows the user to navigate a calendar and select a date.
 *
 * The `DatePicker` includes the logic for picking dates, but not the container within which it will generally be used.
 * For most use cases, use the `DatePickerDialog`. Use the `DatePicker` directly when you need a different, custom container.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { DatePicker } from "@panwds/react-ui";
 * ```
 */
const DatePicker = ({ dataMetrics, dataTestId, initialDate = startOfDay(new Date()), max = MAX_DATE, min = MIN_DATE, onApply, onCancel = noop, weekStartsOn = 0, disabled = false }) => {
    const [activeDate, setActiveDate] = useActiveDate({
        initialActiveDate: initialDate,
        max,
        min
    });
    const [selectedDate, setSelectedDate] = useState(initialDate);
    const intl = useIntl();
    function handleSelectDate(next) {
        setSelectedDate(next);
        setActiveDate(next);
    }
    return (React.createElement(DatePickerLayout, { dataMetrics: dataMetrics, dataTestId: dataTestId || 'date-picker', actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: () => {
                    onCancel();
                }, disabled: disabled }, intl.formatMessage(cancelMessage)),
            React.createElement(Button, { appearance: "primary", onClick: () => {
                    onApply(selectedDate);
                }, disabled: disabled }, intl.formatMessage(applyMessage))), calendar: React.createElement(Calendar, { activeDate: activeDate, max: max, min: min, onActiveDateChange: setActiveDate, onSelectedDateChange: handleSelectDate, selectedDate: selectedDate, weekStartsOn: weekStartsOn }), inputs: React.createElement(Field, { label: "Date", showLabel: false, control: React.createElement(DateInput, { selectedDate: selectedDate, onSelectDate: handleSelectDate }) }) }));
};

export { DatePicker };
//# sourceMappingURL=DatePicker.esm.js.map
